import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props) {
  var mp = '@media print';
  var mq = "@media screen and (".concat(componentTheme.phoneBreakPoint, ")");
  return {
    itemWrapper: _defineProperty({
      borderTop: "".concat(componentTheme.itemWrapperBorderWidth, " solid ").concat(componentTheme.itemWrapperBorderColor),
      display: 'flex',
      '&:first-of-type': {
        borderColor: 'transparent'
      }
    }, mp, {
      breakInside: 'avoid'
    }),
    stimulusItem: {
      flex: '1 1 auto'
    },
    linesStyles: _objectSpread(_objectSpread({}, !props.horizontallyAligned && {
      flex: '0 0 1rem',
      borderLeft: "".concat(componentTheme.phoneConnectingLinesBorderWidth, " dotted"),
      borderBottom: "".concat(componentTheme.phoneConnectingLinesBorderWidth, " dotted"),
      borderColor: componentTheme.phoneConnectingLinesBorderColor,
      marginTop: componentTheme.phoneConnectingLinesMargin,
      marginRight: componentTheme.phoneConnectingLinesMargin,
      height: '2rem',
      width: '1.5rem'
    }), {}, _defineProperty({}, mq, {
      flex: '0 0 1rem',
      borderLeft: "".concat(componentTheme.phoneConnectingLinesBorderWidth, " dotted"),
      borderBottom: "".concat(componentTheme.phoneConnectingLinesBorderWidth, " dotted"),
      borderColor: componentTheme.phoneConnectingLinesBorderColor,
      marginTop: componentTheme.phoneConnectingLinesMargin,
      marginRight: componentTheme.phoneConnectingLinesMargin,
      height: '2rem',
      width: '1.5rem'
    }))
  };
};
export default generateStyle;